import React from "react";
import styled from "styled-components";
import {useNavigate} from "react-router-dom";
import spriteImage from "../../assets/images/sprite.png";
import tabImage1 from "../../assets/images/tab_image_01.jpg";
import tabImage2 from "../../assets/images/tab_image_02.jpg";
import tabImage3 from "../../assets/images/tab_image_03.jpg";
import tabImage4 from "../../assets/images/tab_image_04.jpg";
import {device} from "../../assets/styles/media.js";
import decodeEntities from "../../util/decodeEntities";

const ContentsInner = styled.div`
    display: flex;
    max-width: 100vw;
    box-sizing: border-box;
    margin: 0 auto;
    justify-content: center;
    padding: 70px 0;
    scrollbar-width: none;
    width: 100%;
    overflow: hidden;

    div:last-child {
        padding-right: 0;
        margin-right: 0;
    }

`;
const ContentsItem = styled.div`
    position: relative;
    cursor: pointer;
    width: ${(props) => (props.active ? "38%" : "320px")};
    margin-right: 1%;
    box-sizing: border-box;
    transition: width 0.5s ease;

    ul {
        display: block;
        opacity: ${(props) => (props.active ? 1 : 0)};
        max-height: ${(props) => (props.active ? "600px" : "0")};
        transition: opacity 0.3s ease, max-height 0.3s ease;
        pointer-events: ${(props) => (props.active ? "auto" : "none")};
    }

    ${device.pc2} {
        width: ${(props) => (props.active ? "38%" : "250px")};
    }

    ${device.pc} {
        width: ${(props) => (props.active ? "38%" : "20%")};
    }
`;
const ContentTitle = styled.div`
    display: flex;
    justify-content: center;
    width: 320px;
    height: 587px;
    padding-top: 108px;
    cursor: pointer;
    border-radius: 10px;
    background-size: cover;
    background-image: url(${({$bgImage}) => {
        switch ($bgImage) {
            case 1:
                return tabImage1;
            case 2:
                return tabImage2;
            case 3:
                return tabImage3;
            case 4:
                return tabImage4;
            default:
                return tabImage1;
        }
    }});

    ${device.pc2} {
        justify-content: center;
        width: 250px;
    }

    ${device.pc} {
        width: 200px;
    }
`;
const ContentList = styled.ul`
    position: absolute;
    top: 100px;
    right: 10px;
    width: 52%;
    box-sizing: border-box;
    flex-direction: column;
    justify-content: center;
    opacity: ${(props) => (props.active ? 1 : 0)};
    max-height: ${(props) => (props.active ? "800px" : "0")};
    overflow: hidden;
    transition: opacity 0.3s ease, max-height 0.3s ease;
    pointer-events: ${(props) => (props.active ? "auto" : "none")};
    padding: 0 30px;


    ${device.pc2} {
        line-height: 30px;
      
    }
`;
const TitleTxt = styled.strong`
    position: relative;
    padding-right: 25px;
    color: #fff;
    font-size: 22px;
    font-weight: 600;
    letter-spacing: 15px;

    ${device.pc} {
        letter-spacing: 8px;
    }

`;
const Arrow = styled.span`
    &::after {
        content: "";
        position: absolute;
        top: 0;
        right: 0;
        width: 24px;
        height: 24px;
        background-image: url(${spriteImage});
        background-size: 418px, 402px;
        background-position: -378px -218px;
    }
`;
const Item = styled.li`
    padding-top: ${(props) => (props.active ? "0%" : "15.6%")};
    border-bottom: ${({$isLast}) => ($isLast ? "none" : "1px solid #c6c6c6")};
    padding-bottom: ${({$isLast}) => ($isLast ? "0" : "15.6%")};

`;
const Link = styled.a``;
const Kind = styled.span`
    color: #362579;
    font-weight: 600;
    font-size: 15px;
    line-height: 26px;
`;
const ListTitle = styled.strong`
    display: block;
    padding-top: 7px;
    color: #3b3b3b;
    font-weight: 600;
    font-size: 22px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;

    ${device.pc} {
        font-size: 18px;
    }
`;
const ListDesc = styled.p`
    max-height: 50px;
    padding-top: 7px;
    color: #3b3b3b;
    font-size: 17px;
    line-height: 26px;
    font-weight: 400;
    letter-spacing: -0.8px;
    display: -webkit-box;
    word-wrap: break-word;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    text-overflow: ellipsis;

    ${device.tablet} {
        white-space: pre-line;
    }
`;
const HomeContents = ({list}) => {
    const navigate = useNavigate();
    return (
        <ContentsInner>
            {list?.map((item, index) => (
                <ContentsItem
                    key={item.title}
                    active={0 === index}
                >
                    <ContentTitle
                        $bgImage={index + 1}
                        active={0 === index}
                        onClick={() => navigate(item.link)}
                    >
                        <TitleTxt>
                            {item.title}
                            <Arrow/>
                        </TitleTxt>
                    </ContentTitle>
                    {index === 0 ?
                    <ContentList>
                        {item.subList.map((subItem, subIndex) => (
                            <Item
                                key={subItem.postId}
                                active={subIndex === 0}
                                $isLast={subIndex === item.subList.length - 1}
                            >
                                <Link
                                    onClick={() => navigate(subItem.apiUrl)}
                                >
                                    <Kind>{subItem.category}</Kind>
                                    <ListTitle>{decodeEntities(subItem.subject)}</ListTitle>
                                    <ListDesc>{decodeEntities(subItem.descLine)}</ListDesc>
                                </Link>
                            </Item>
                        ))}
                    </ContentList>:""}
                </ContentsItem>
            ))}
        </ContentsInner>
    );
};

export default HomeContents;
